import { useState, useEffect } from 'react';

function App() {
  const [currentView, setCurrentView] = useState<'player' | 'auction'>('player');
  const [selectedCoinId, setSelectedCoinId] = useState<number | null>(null);
  const [availableCoins, setAvailableCoins] = useState<number[]>([]);

  // Load available coins from the player API
  useEffect(() => {
    const loadCoins = async () => {
      try {
        const response = await fetch('https://originalspins-player-production.hxgp8t6ydd.workers.dev/coins');
        const data = await response.json();
        const coinIds = data.coins?.map((coin: any) => coin.i) || [];
        setAvailableCoins(coinIds);
      } catch (error) {
        console.error('Error loading coins:', error);
      }
    };

    loadCoins();
  }, []);

  const handleCoinClick = (coinId: number) => {
    setSelectedCoinId(coinId);
    setCurrentView('auction');
  };

  const handleBackToPlayer = () => {
    setCurrentView('player');
    setSelectedCoinId(null);
  };

  return (
    <div className="unified-container">
      {currentView === 'player' && (
        <PlayerIframe 
          availableCoins={availableCoins}
          onCoinClick={handleCoinClick}
        />
      )}
      
      {currentView === 'auction' && selectedCoinId && (
        <AuctionIframe 
          coinId={selectedCoinId}
          onBack={handleBackToPlayer}
        />
      )}
    </div>
  );
}

// Player iframe with coin click overlay
const PlayerIframe: React.FC<{ 
  availableCoins: number[];
  onCoinClick: (coinId: number) => void;
}> = ({ availableCoins, onCoinClick }) => {
  return (
    <div className="player-iframe-container">
      <iframe
        src="https://originalspins-player-production.hxgp8t6ydd.workers.dev"
        className="player-iframe"
        title="Original Spins Player"
        allow="autoplay; encrypted-media"
      />
      
      {/* Coin click overlay */}
      <div className="coin-overlay">
        <div className="coin-grid">
          {availableCoins.map((coinId) => (
            <button
              key={coinId}
              className="coin-button"
              onClick={() => onCoinClick(coinId)}
              title={`Click to view Coin #${coinId} auction`}
            >
              #{coinId}
            </button>
          ))}
        </div>
        <div className="coin-overlay-text">
          Click any coin to view its auction
        </div>
      </div>
    </div>
  );
};

// Auction iframe - embeds your existing auction
const AuctionIframe: React.FC<{ 
  coinId: number; 
  onBack: () => void; 
}> = ({ coinId, onBack }) => {
  const auctionUrl = `https://originalspins-auction-production.hxgp8t6ydd.workers.dev/?pieceId=${coinId}&v=fromPlayer`;

  return (
    <div className="auction-iframe-container">
      <div className="auction-header">
        <button onClick={onBack} className="back-button">
          ← Back to Player
        </button>
        <h2>Coin #{coinId} Auction</h2>
      </div>
      <iframe
        src={auctionUrl}
        className="auction-iframe"
        title={`Coin ${coinId} Auction`}
      />
    </div>
  );
};

export default App;